import { Reveal } from "@components/ui";

const terms = [
  "Held against unpaid invoices, damages, or liabilities.",
  "Fully refundable within 7–10 working days after account closure and final bill settlement.",
  "May be transferred to another GASIS property if account continues.",
];

const deposits = [
  { type: "Studio / Retail Kiosk", amount: "250" },
  { type: "1 Bedroom", amount: "300" },
  { type: "2 Bedrooms", amount: "400" },
  { type: "3 Bedrooms", amount: "500" },
  { type: "Penthouse / Retail Outlet", amount: "1,000" },
];

export function SecurityDepositSection() {
  return (
    <section className="w-full bg-[#f6f6f9] overflow-hidden pt-8 md:pt-12 lg:pt-[80px] pb-6 md:pb-8 lg:pb-[48px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-8 md:gap-12 lg:gap-10">
          <Reveal direction="left" className="flex-1 min-w-0">
            <div className="flex flex-col gap-4 md:gap-[22.5px]">
              <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase font-albert-sans w-fit">
                Deposits
              </span>
              <h2 className="text-[24px] md:text-[40px] lg:text-[54px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1]">
                Security Deposit Details
              </h2>
              <div className="flex flex-col gap-2 md:gap-[9px]">
                <h3 className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] leading-[32px] font-normal text-[#62636c] font-albert-sans">
                  Terms:
                </h3>
                <div className="flex flex-col gap-3 md:gap-4">
                  {terms.map((term) => (
                    <div key={term} className="flex items-start gap-3">
                      <div className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-[#122d63]/8 flex items-center justify-center shrink-0 mt-0.5">
                        <svg viewBox="0 0 24 24" fill="none" className="w-3.5 h-3.5 md:w-4 md:h-4">
                          <path
                            d="M5 12l5 5L20 7"
                            stroke="#122d63"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] leading-[32px] text-[#62636c] font-albert-sans">
                        {term}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal direction="right" className="w-full lg:w-[600px] shrink-0">
            <div className="rounded-[12px] md:rounded-[16px] border border-[#62636C33] bg-white overflow-hidden">
              <div className="rounded-t-[12px] md:rounded-t-[16px] bg-[#f24d2b] flex items-center py-3 md:py-[12px] px-4 md:px-[16px]">
                <h3 className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] leading-[32px] font-normal text-white font-albert-sans">
                  Deposits per Unit Type
                </h3>
              </div>
              {deposits.map((deposit) => (
                <div
                  key={deposit.type}
                  className="grid grid-cols-[1fr_auto] border-b border-[#62636C33] last:border-b-0 hover:bg-[#f8f9fb] transition-colors duration-200 group"
                >
                  <div className="border-r border-[#62636C33] py-2.5 md:py-[8px] px-4 md:px-[15px]">
                    <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] leading-[32px] text-[#62636c] font-albert-sans">
                      {deposit.type}
                    </p>
                  </div>
                  <div className="py-2.5 md:py-[8px] px-4 md:px-[16px] min-w-[100px] md:min-w-[120px]">
                    <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] leading-[32px] text-[#62636c] font-albert-sans group-hover:text-[#122d63] group-hover:font-semibold transition-all duration-200">
                      {deposit.amount}
                      <span className="text-[12px] md:text-[16px]"> AED</span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
